import { Component, ComponentRef, Input, OnDestroy, OnInit, QueryList, ViewChildren, ViewContainerRef } from '@angular/core';
import { DynamicUiService } from '../../services/dynamic-ui.service'
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicBaseClass } from '../../controls/dynamic-base-class/dynamic-base-class.component';
import { UiDefinition } from '../../models/ui-definition.models';
import { DynamicFacade } from '../../store/dynamic.facade';
import { AppFacade } from 'src/app/app/store/app.facade';
import { distinctUntilChanged, first, last, Observable, Subject, Subscription, take, takeUntil } from 'rxjs';
import { AppConstants } from 'src/app/app/helpers/app-constants';
import { isEqual } from 'lodash-es';

@Component({
  standalone: false,
    selector: 'app-dynamic',
    templateUrl: './dynamic.component.html',
    styleUrls: ['./dynamic.component.scss']
})
export class DynamicComponent implements OnInit, OnDestroy {

    uiDefinition$: Observable<any> = this.dynamicFacade.uiDefinition$;

    componentRef: ComponentRef<DynamicBaseClass>;
    protected destroy$ = new Subject<void>();

    public uiDefinition: UiDefinition;

    @ViewChildren('children', { read: ViewContainerRef }) viewChildrenRef: QueryList<ViewContainerRef>;

    constructor(
        private appFacade: AppFacade,
        private dynamicFacade: DynamicFacade,
        private dynamicUiServices: DynamicUiService,
        private router: Router,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
            //console.log(' ***** UI definition init');
            this.uiDefinition$
            .pipe(
                takeUntil(this.destroy$),
                distinctUntilChanged(isEqual)
            )
            .subscribe(c => {
                if (c) {
                    //console.log(' ***** UI definition changed, updating view.', c);
                    this.InitDynamicComponent(c);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    InitDynamicComponent(uiDefinition: UiDefinition): void {
        this.uiDefinition = uiDefinition;
        this.dynamicUiServices.InitService();
        this.dynamicFacade.InitLocalStore(uiDefinition?.definition ?? []);
        this.appFacade.SetTitle(uiDefinition?.title);
        this.dynamicUiServices.SetValue(AppConstants.dataStoreUrlQueryParameters, [], this.activatedRoute.snapshot.queryParams);
        this.InitView();
    }

    InitView(): void {
        if (this.uiDefinition?.definition) {
            setTimeout(() => {
                //console.log(' ***** Initializing dynamic component view with definition.',this.uiDefinition.name);
                this.viewChildrenRef.map((vcr: ViewContainerRef, index: number) => {
                    vcr.clear();
                    const component = this.dynamicUiServices.GetComponent(this.uiDefinition.definition[index])?.component;
                    if (component) {
                        this.componentRef = vcr.createComponent(component);
                        this.componentRef.instance.children = this.uiDefinition.definition[index].children;
                        this.componentRef.instance.config = this.uiDefinition.definition[index].config;
                    }
                })
            });
        }
    }

}
